export enum UserTypeEnum {
  PRIMARY_GUEST = 'PRIMARY_GUEST',
  SECONDARY_GUEST = 'SECONDARY_GUEST',
}
